<script>
  import {TableColumn} from 'element-ui';
  export default {
    extends: TableColumn
  };
</script>